module.exports = __webpack_public_path__ + "roboto-v15-latin-300.634f53eb79efa455a9e9.ttf";


//////////////////
// WEBPACK FOOTER
// A:/CM/links-ui/cm-ui-app-links/src/assets/layout/fonts/roboto-v15-latin-300.ttf
// module id = ../../../../../src/assets/layout/fonts/roboto-v15-latin-300.ttf
// module chunks = styles